import React , { useState , useEffect}  from 'react'
import { Link } from 'react-router-dom';
import Messagerie from './Messagerie/Messagerie'
import Ficheetudiant from './FicheEtudiant/ficheetudiant'
import Emploi from './Emploi/Emploi'
import CalandrierExamens from './Calandrier/CalandrierExamens'
import Abscence from './Abscence/Abscence';
import Ratrappage from './Ratrappage/Ratrappage';
import AvisExamen from './AvisExamen';
import Deleberation from './Deleberation';
import Nouveaute from './Nouveauté/Nouveaute';

import './DashbordEtudiant.css'
import './LeftContent.css'

function LeftContent(props) {
  const [selectedTab2, setSelectedTab2] = useState(props.uid);
  /*console.log(props.uid , 'props from leftcontent')*/

  useEffect(() => {
    setSelectedTab2(props.uid);
    /*console.log(selectedTab2 , 'from leftcontent')*/

  }, [props.uid]);

  const handleTabClick = (tabName) => {
    setSelectedTab2(tabName);
   /* console.log(selectedTab2 , 'from leftcontent 2')*/

};
  return (
    <>
      <div className='contantdashbord'>
        <div className='dash'>
            <button  className='navigationespaceetudiant' onClick={() => handleTabClick('Nouveauté')} ><Link to="/DashbordEtudiant/Nouveautés" className='linkdash' ><span>Nouveauté</span></Link></button>
            <button className='navigationespaceetudiant' onClick={() => handleTabClick('Messagerie')}><Link to="/DashbordEtudiant/Messagerie" className='linkdash' > <span>Messagerie</span> </Link></button>
            <button className='navigationespaceetudiant' onClick={() => handleTabClick('Fiche étudiant')}><Link to="/DashbordEtudiant/Fiche étudiant" className='linkdash' ><span>Fiche étudiant</span></Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Emploi de temps')}><Link to="/DashbordEtudiant/Emploi de temps" className='linkdash' ><span>Emploi de temps</span></Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Calendrier des examens')}><Link to="/DashbordEtudiant/Calendrier des examens" className='linkdash' ><span>Calendrier des examens</span></Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Liste des avis absence')}><Link to="/DashbordEtudiant/Liste des avis d'absence" className='linkdash'><span>Liste des avis d'absence</span></Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Avis de rattrapages')}><Link to="/DashbordEtudiant/Avis de rattrapages" className='linkdash' ><span>Avis de rattrapages</span></Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Avis dexamens')}><Link to="/DashbordEtudiant/Avis d'examens" className='linkdash' > <span>Avis d'examens</span> </Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Bibliothèque')}><Link to="/DashbordEtudiant/Bibliothèque" className='linkdash' ><span> Bibliothèque</span></Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Demandes en ligne')}><Link to="/DashbordEtudiant/Demandes en ligne" className='linkdash' ><span> Demandes en ligne</span></Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Délebération')}><Link to="/DashbordEtudiant/Délebération" className='linkdash' ><span>Délebération</span> </Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Liste des supports pédagogiques')}><Link to="/DashbordEtudiant/Liste des supports pédagogiques" className='linkdash' ><span>Liste des supports pédagogiques</span> </Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Espace Téléchrgement')}><Link to="/DashbordEtudiant/Espace Téléchrgement" className='linkdash' ><span>Espace Téléchrgement</span> </Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Stage et PFE')}><Link to="/DashbordEtudiant/Stage et PFE" className='linkdash' ><span>Stage et PFE</span> </Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Stage facultatifs')}><Link to="/DashbordEtudiant/Stage facultatifs" className='linkdash' ><span> Stage facultatifs</span></Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Stage Obligatoire')}><Link to="/DashbordEtudiant/Stage Obligatoire" className='linkdash' ><span>Stage Obligatoire</span> </Link></button>   
            <button className='navigationespaceetudiant'onClick={() => handleTabClick('Boite de proposition')}><Link to="/DashbordEtudiant/Boite de proposition" className='linkdash' ><span> Boite de proposition</span></Link></button>   
        </div>
     
        <div className='contenutab'>
        {( selectedTab2 === 'Nouveauté') && <Nouveaute/>}
        {(  selectedTab2 === 'Messagerie')  && <Messagerie/>}
        {(selectedTab2 === 'Fiche étudiant')  && <Ficheetudiant/>}
         {( selectedTab2 === 'Emploi de temps') && <Emploi/>}
         {( selectedTab2 === 'Calendrier des examens') && <CalandrierExamens/>}
         {(selectedTab2 === "Liste des avis d'absence") && <Abscence/>}
         {(selectedTab2 === 'Avis de rattrapages') && <Ratrappage/>}
         {( selectedTab2 === "Avis d'examens") && <AvisExamen/>}
     
         {( selectedTab2 === 'Délebération') && <Deleberation/>}




        </div>
   </div>
    </>
  
  )
}

export default LeftContent